import { useState } from 'react';
import { Tooltip, useMediaQuery, useTheme } from '@mui/material';

const ClickTooltip = ({ title, children, ...props }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

  const handleTooltipOpen = () => {
    if (isSmallScreen) {
      setOpen(true);
      // Auto close after 2 seconds
      setTimeout(() => setOpen(false), 2000);
    }
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

  return (
    <Tooltip
      title={title}
      arrow
      placement="top"
      open={isSmallScreen ? open : undefined}
      onOpen={isSmallScreen ? handleTooltipOpen : undefined}
      onClose={isSmallScreen ? handleTooltipClose : undefined}
      disableHoverListener={isSmallScreen}
      disableFocusListener={isSmallScreen}
      disableTouchListener={isSmallScreen}
      slotProps={{
        popper: {
          popperOptions: {
            strategy: 'fixed',
          },
        },
      }}
      {...props}
    >
      <span onClick={isSmallScreen ? handleTooltipOpen : undefined}>
        {children}
      </span>
    </Tooltip>
  );
};

export default ClickTooltip;